import(/* webpackMode: "eager" */ "/vercel/path0/components/common/AvailabilityBadge.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/forms/QuoteForm.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")